import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {DsiInfo} from '../shared/models/dsi-info';

@Injectable({
  providedIn: 'root',
})
export class DsiService {
  constructor(private http: HttpClient) { }

  getDsiOverviewInfos(dealerNumber: string | null): Observable<DsiInfo> {
    const url = dealerNumber === null
      ? environment.endpoints.DSI.dsiInfo.replace('/{dealerNumber}', '')
      : environment.endpoints.DSI.dsiInfo.replace('{dealerNumber}', dealerNumber);
    return this.http.get<DsiInfo>(url);
  }

  getDsiDocumentHtml(brand: string, version: string, dealerNumber: string) {
    const url = environment.endpoints.DSI.getDsiDocumentHtml
      .replace('{brand}', brand)
      .replace('{version}', version)
      .replace('{dealerNumber}', dealerNumber);
    window.open(url, '_blank');
  }

  getDsiDocumentPdf(brand: string, version: string, dealerNumber: string) {
    const url = environment.endpoints.DSI.getDsiDocumentPdf
      .replace('{brand}', brand)
      .replace('{version}', version)
      .replace('{dealerNumber}', dealerNumber);
    window.open(url, '_blank');
  }
}
